// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepTree-module__colorBox--eNff9 {
    margin: 20px 0;
    display: flex;
    gap: 10px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: #e2e9ff;
    border-radius: 20px;
    padding: 5px;
}

.StepTree-module__colorBox--eNff9>p {
    margin: 0;
}

.StepTree-module__colorBox--eNff9>p {
    margin: 0;
}

.StepTree-module__icon--n1iyV>svg {
    color: var(--color-primary);
    font-size: 25px;
}

.StepTree-module__titleBox--VVuEo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;

}

.StepTree-module__titleBox--VVuEo>span {
    color: var(--color-primary);
    font-weight: bold;
    font-size: 30px;

}

.StepTree-module__titleBox--VVuEo>h4 {
    color: var(--color-title);
    font-weight: bold;

}

.StepTree-module__spanIcon--iR1bX>svg {
    color: var(--color-primary);
    font-weight: bold;
    font-size: 25px;
}

.StepTree-module__btnBox--h5XZ7 {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
}

.StepTree-module__successMessage--LPxae {
    display: flex;
    flex-direction: column;
    color: green;
    font-size: 30px;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
}

.StepTree-module__successMessage--LPxae>p {
    color: green;
    font-size: 30px;
    font-weight: bold;
}

.StepTree-module__successMessage--LPxae>span>svg {
    color: green;
    font-size: 90px;
}

.StepTree-module__fullWidthBox--_V2LX>div {
    width: 100%;
}

.StepTree-module__FileItemBorder--OTNIt {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 10px;
}

.StepTree-module__FileItem--WH9TG {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 10px;
}

.StepTree-module__FileItemBorder--OTNIt>a,
.StepTree-module__FileItem--WH9TG>a {
    color: #6F879C;
    text-decoration: none;
}


.StepTree-module__infoText--MBY8N {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.StepTree-module__infoText--MBY8N>p {
    color: #4b5b69;
    font-size: 18px;
}

.StepTree-module__btnDownload--ckToq {
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/features/mite-policy/step-3/StepTree.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;;AAEzB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;;AAEnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;;AAErB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,cAAc;IACd,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".colorBox {\r\n    margin: 20px 0;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #e2e9ff;\r\n    border-radius: 20px;\r\n    padding: 5px;\r\n}\r\n\r\n.colorBox>p {\r\n    margin: 0;\r\n}\r\n\r\n.colorBox>p {\r\n    margin: 0;\r\n}\r\n\r\n.icon>svg {\r\n    color: var(--color-primary);\r\n    font-size: 25px;\r\n}\r\n\r\n.titleBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    align-content: center;\r\n\r\n}\r\n\r\n.titleBox>span {\r\n    color: var(--color-primary);\r\n    font-weight: bold;\r\n    font-size: 30px;\r\n\r\n}\r\n\r\n.titleBox>h4 {\r\n    color: var(--color-title);\r\n    font-weight: bold;\r\n\r\n}\r\n\r\n.spanIcon>svg {\r\n    color: var(--color-primary);\r\n    font-weight: bold;\r\n    font-size: 25px;\r\n}\r\n\r\n.btnBox {\r\n    display: flex;\r\n    margin-top: 20px;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.successMessage {\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: green;\r\n    font-size: 30px;\r\n    font-weight: bold;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 50px;\r\n}\r\n\r\n.successMessage>p {\r\n    color: green;\r\n    font-size: 30px;\r\n    font-weight: bold;\r\n}\r\n\r\n.successMessage>span>svg {\r\n    color: green;\r\n    font-size: 90px;\r\n}\r\n\r\n.fullWidthBox>div {\r\n    width: 100%;\r\n}\r\n\r\n.FileItemBorder {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin: 10px;\r\n}\r\n\r\n.FileItem {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin: 10px;\r\n}\r\n\r\n.FileItemBorder>a,\r\n.FileItem>a {\r\n    color: #6F879C;\r\n    text-decoration: none;\r\n}\r\n\r\n\r\n.infoText {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.infoText>p {\r\n    color: #4b5b69;\r\n    font-size: 18px;\r\n}\r\n\r\n.btnDownload {\r\n    display: flex;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorBox": `StepTree-module__colorBox--eNff9`,
	"icon": `StepTree-module__icon--n1iyV`,
	"titleBox": `StepTree-module__titleBox--VVuEo`,
	"spanIcon": `StepTree-module__spanIcon--iR1bX`,
	"btnBox": `StepTree-module__btnBox--h5XZ7`,
	"successMessage": `StepTree-module__successMessage--LPxae`,
	"fullWidthBox": `StepTree-module__fullWidthBox--_V2LX`,
	"FileItemBorder": `StepTree-module__FileItemBorder--OTNIt`,
	"FileItem": `StepTree-module__FileItem--WH9TG`,
	"infoText": `StepTree-module__infoText--MBY8N`,
	"btnDownload": `StepTree-module__btnDownload--ckToq`
};
export default ___CSS_LOADER_EXPORT___;
